import { bindStateToDb } from '@/utilities/db-helpers'

export default {
  namespaced: true,

  state() {
    return {
      combatant: {},
    }
  },

  actions: {
    bindCombatantRef: bindStateToDb(`combatant`, `combatants`),

    update(
      // eslint-disable-next-line
      { dispatch },
      { id, battles, ...data }
    ) {
      const updates = {}

      Object.keys(battles).forEach(battle => {
        Object.entries(data).forEach(([key, value]) => {
          updates[`/battleCombatants/${battle}/${id}/meta/${key}`] = value
        })
      })

      Object.entries(data).forEach(([key, value]) => {
        updates[`/combatants/${id}/${key}`] = value
      })

      return dispatch(`updateDb`, updates, { root: true })
    },
  },
}
